export const API_ROOT = 'https://api-edge-dev.inherinext.compassbioinfo.com/'
// export const API_ROOT = 'https://server-edge.inherinext.com/'

export const WS_ROOT = 'wss://api-edge-dev.inherinext.compassbioinfo.com/cable'
// export const WS_ROOT = 'wss://server-edge.inherinext.com/cable'


// WEBPACK FOOTER //
// ./src/api/config.js